import { Operatory } from 'interfaces/operatory';
import { omit } from 'lodash';
import { Option } from 'pages/PractitionerPage/MainSection/PractitionerProfile/MultipleSelect/MultipleSelect';

interface AdvancedWorkingHour {
  start: string | null;
  end: string | null;
  operatoryIds: string[] | null;
}

interface AdvancedWeeklySchedule {
  id: string;
  mon: AdvancedWorkingHour[];
  tue: AdvancedWorkingHour[];
  wed: AdvancedWorkingHour[];
  thu: AdvancedWorkingHour[];
  fri: AdvancedWorkingHour[];
  sat: AdvancedWorkingHour[];
  sun: AdvancedWorkingHour[];
}

const normalizeAdvancedWeeklySchedule = (
  advancedWeeklySchedule: AdvancedWeeklySchedule,
  operatories: Operatory[]
) => {
  const removeIdFields = omit(advancedWeeklySchedule, ['id', 'lunchBreaks']);

  const normalizeData = Object.entries(removeIdFields);

  const timeSlots = normalizeData.map((data) => {
    const [day, time] = data;
    // The timesheet here only have 1 array
    const { start, end, operatoryIds } = time[0] as any;

    const result: {
      day: string;
      start: string | null;
      end: string | null;
      operatories: Option[];
    } = {
      day,
      start,
      end,
      operatories: [],
    };

    if (!operatoryIds) {
      return result;
    }

    operatories.forEach((operatory) => {
      if (operatoryIds?.includes(operatory.id)) {
        result.operatories.push({ label: operatory.name, value: operatory.id });
      }
    });

    return result;
  });

  const sun = timeSlots.pop()!;
  timeSlots.unshift(sun);
  return timeSlots;
};

export default normalizeAdvancedWeeklySchedule;
